import styled from 'styled-components'

export const DateSpan = styled.span`
  font-weight: 900;
`

DateSpan.displayName = 'DateSpan'
